/**
 * Configuration for unfavourite confirmation modal
 * Used across ReviewPerformanceTab, KeyActivitiesTab, and TopOpportunitiesSection
 */

export interface UnfavouriteModalConfig {
  header: string;
  primaryButton: string;
  secondaryButton: string;
  bodyLine1: string;
  bodyLine2: string;
}

export type UnfavouriteSourceArea = 'review-performance' | 'key-activities' | 'top-opportunities';

/**
 * Modal content mapped by source area
 */
export const UNFAVOURITE_MODAL_CONTENT: Record<UnfavouriteSourceArea, UnfavouriteModalConfig> = {
  'review-performance': {
    header: 'Remove activity',
    primaryButton: 'Remove',
    secondaryButton: 'Cancel',
    bodyLine1: "Are you sure you want to remove this item from your Selected KPI's list?",
    bodyLine2: "Unstaring the item would turn it into a below regular KPI's list.",
  },
  'key-activities': {
    header: 'Remove activity',
    primaryButton: 'Remove',
    secondaryButton: 'Cancel',
    bodyLine1: "Are you sure you want to remove this item from your Selected Lighthouse Task's list?",
    bodyLine2: "Unstaring the item would turn it into a below regular Lighthouse Task's list.",
  },
  'top-opportunities': {
    header: 'Remove activity',
    primaryButton: 'Remove',
    secondaryButton: 'Cancel',
    bodyLine1: 'Are you sure you want to remove this item from your Top Opportunities list?',
    bodyLine2: 'Unstaring the item would turn it into a regular action plan.',
  },
};

/**
 * Get modal configuration for a specific source area
 */
export const getUnfavouriteModalConfig = (sourceArea: UnfavouriteSourceArea): UnfavouriteModalConfig => {
  return UNFAVOURITE_MODAL_CONTENT[sourceArea];
};
